import { useEffect, useState } from "react";
import ComponentHandler from "../common-module/ComponentHandler";
import CommonTable from "../common-module/CommonTable";
import CustomLoader from "../../custom-ui/CustomLoader";
import NoRecord from "../common-module/NoRecord";
import { getRequestForApi } from "../../utility-files/api-util/CommonRequest";
import { callHttpRequest, methodType, } from "../../utility-files/api-util/HttpRequest";
import { alertTypes, downloadXMLfile, formatUniversalNumber, jsonToXLSXFile, } from "../../utility-files/helper-function/HelperFunction";
import { useAlert } from "react-alert";
import { FETCH_ALL_OWNERS_DATA, DOWNLOAD_ALL_OWNERS_DATA, DOWNLOAD_EXCEL_FILE, } from "../../constants/global";
import { isStringValue, stringValueLowerCase, } from "../../utility-files/data-util/DataHandling";
import TableContentHandler from "../../qed-theme-module/TableContentHandler";
import ThemeButton from "../../qed-theme-module/ThemeButton";
import { IMAGE_TYPES } from "../../utility-files/default-values/DefaultValues";
import OwnerViewData from "../../custom-popup-model/OwnerViewData";
import Image from "../common-module/Image";
import ApiHelper from "../../config/ApiHelper";
import moment from "moment";
import OwnwerSendMessage from "../../custom-popup-model/OwnerSendMessage";

function Reports({ user_details, themeData }) {
  const [data, setData] = useState(null);
  const [pending, setPending] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [item, setItem] = useState("");
  const [attributes, setAttributes] = useState([""]);
  const [toDate, setToDate] = useState("");
  const [search, setSearch] = useState("");
  const [isShowModel, setIsShowModel] = useState(false);
  const [ownerData, setOwnerData] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [clearSelection, setClearSelection] = useState(false);
  const [isSendButtonEnabled, setIsSendButtonEnabled] = useState(false);
  const [resetFilters, setResetFilters] = useState(false);


  const role = user_details?.role;
  const alert = useAlert();

  const elementStyle = {
    fontFamily: isStringValue(themeData?.fontName),
    color: isStringValue(themeData?.textColor),
  };

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  useEffect(() => {
    if (resetFilters) {
      getOwnerDataList("", "", "", [""]);
      setResetFilters(false);
    }
  }, [resetFilters]);

  const debouncedSearch = debounce((value) => {
    setSearch(value);
  }, 500);

  useEffect(() => {
    getOwnerDataList();
  }, [search]);

  useEffect(() => {
    if (clearSelection) {
      setClearSelection(false);
    }
  }, [clearSelection]);

  const handleCreate = (row) => {
    setIsShowModel(!isShowModel);
    setOwnerData(row?.messageData);
  };

  const handleModel = () => {
    setShowModel(!showModel);
    if (showModel) {
      setIsSendButtonEnabled(false);
      setSelectedRows([]);
      setClearSelection(true);
    }
  };

  const handleRowSelected = (selected) => {
    setSelectedRows(selected.selectedRows);
    setIsSendButtonEnabled(selected.selectedRows.length > 0);
  };

  const getOwnerDataList = async (from = fromDate, to = toDate, filterItem = item, attrArr = attributes) => {
    setPending(true);
    const attrObj = {
      attribute: isStringValue(attrArr[0]?.trim()),
      attribute1: isStringValue(attrArr[1]?.trim()),
      attribute2: isStringValue(attrArr[2]?.trim()),
      attribute3: isStringValue(attrArr[3]?.trim()),
      attribute4: isStringValue(attrArr[4]?.trim()),
    };

    const variables = {
      pageNo: 0,
      perPageItem: 0,
      searchText: isStringValue(search),
      fromDate: isStringValue(from),
      toDate: isStringValue(to),
      item: isStringValue(filterItem),
      ...attrObj,
    };

    const request = getRequestForApi(FETCH_ALL_OWNERS_DATA, variables, methodType.POST);
    try {
      const response = await callHttpRequest(request);
      if (response?.status === 201) {
        const res = response?.data?.response?.data;
        setData(res);
        setOwnerData(res);
      }
    } catch (err) {
      alert.show(err?.response?.data?.message, { type: alertTypes.ERROR });
    } finally {
      setPending(false);
    }
  };

  const downloadAllOwnersData = async () => {
    setPending(true);
    try {
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (item) params.append("item", item);
      if (search) params.append("searchText", search);
      if (attributes[0]) params.append("attribute", attributes[0]);
      if (attributes[1]) params.append("attribute1", attributes[1]);
      if (attributes[2]) params.append("attribute2", attributes[2]);
      if (attributes[3]) params.append("attribute3", attributes[3]);
      if (attributes[4]) params.append("attribute4", attributes[4]);

      const url = params.toString().length > 0 ? `${DOWNLOAD_ALL_OWNERS_DATA}?${params.toString()}` : DOWNLOAD_ALL_OWNERS_DATA;
      const response = await ApiHelper.get(url, { responseType: "blob" });
      if (response?.status === 200) {
        downloadXMLfile(
          response?.data,
          `Report_${moment().format()}.xlsx`
        );
        alert.show("File downloaded successfully", {
          type: alertTypes.SUCCESS,
        });
      } else {
        alert.show("Download API failed", { type: alertTypes.ERROR });
      }
    } catch (err) {
      alert.show(err?.response?.data?.message || "Error while downloading", {
        type: alertTypes.ERROR,
      });
    } finally {
      setPending(false);
    }
  };

  const columns = [
    {
      name: <TableContentHandler header={"Name"} />,
      selector: (row) => row.displayName || "N/A",
      sortable: true,
    },
    {
      name: <TableContentHandler header={"Wallet Name"} />,
      selector: (row) => row.walletName || "N/A",
      sortable: true,
    },
    {
      name: <TableContentHandler header={"Email"} />,
      selector: (row) => row.email || "N/A",
      sortable: true,
      wrap: true,
      width: "300px",
    },
    {
      name: <TableContentHandler header={"Contact Number"} />,
      selector: (row) => formatUniversalNumber(row.contactNumber) || "N/A",
      sortable: true,
    },
    {
      name: <TableContentHandler header={"Zip Code"} />,
      selector: (row) => row.zipCode || "N/A",
      sortable: true,
    },
    {
      name: <TableContentHandler header={"Actions"} />,
      sortable: true,
      cell: (row) => (
        <button
          type="button"
          className="btn btn-sm gap-1"
          style={{ marginRight: "6px", display: "flex", alignItems: "center" }}
          onClick={() => handleCreate(row)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-envelope"
            viewBox="0 0 16 16"
          >
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
          </svg>
        </button>
      ),
    },
  ];

  return (
    <ComponentHandler>
      <div className="container-fluid p-4">
        <div className="searchBox">
          <p
            className="filter_btn"
            style={elementStyle}
            data-bs-toggle="modal"
            data-bs-target="#filterModal"
          >
            <Image src={IMAGE_TYPES.FILTER_IMAGE} alt="" /> Filter
          </p>
          <div className="search">
            <input
              type="search"
              placeholder="Type to search"
              className="form-control inputText"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
            <button type="button" className="search_icon">
              <Image src={IMAGE_TYPES.SEARCH_NEW_LOGO} alt="search" />
            </button>
          </div>
        </div>

        <div className="bg-white rounded shadow-sm p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 className="m-0">Owner's Data</h5>
            </div>
            <div className="d-flex align-items-center">
              <ThemeButton
                className="btn btn-primary blue-button right d-flex gap-2"
                onClick={() => handleModel()}
                disabled={!isSendButtonEnabled}
                onSuccess={getOwnerDataList}
              >
                Send Message
              </ThemeButton>{" "}
              &nbsp;&nbsp;
              <button
                className="btn btn-outline-secondary d-flex align-items-center me-2"
                onClick={downloadAllOwnersData}
                disabled={!data || data.length === 0 || pending}
              >
                <i className="bi bi-download me-2"></i>
                Download xlsx
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <CommonTable
              columns={columns}
              data={data}
              fixedHeader={true}
              fixedHeaderScrollHeight={"300px"}
              progressPending={pending}
              progressComponent={<CustomLoader />}
              selectableRows={stringValueLowerCase(role) !== "user"}
              noDataComponent={<NoRecord />}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={clearSelection}
              onRowClicked={(row) => { }}
            />
          </div>
        </div>

        <div
          className="modal fade"
          id="filterModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Filter Reports</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div class="mb-3 gap-2 justify-content-between item-attribute-section reports-col">
                  <div className="column" style={{ marginBottom: "5px"}}>
                     <label className="form-label form-label-date">From Date</label>
                    <input
                      type="date"
                      className="inputText2 inputText2-ps"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      onKeyDown={(e) => e.preventDefault()}
                      onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    />
                  </div>
                  <div className="column" style={{ marginBottom: "5px"}}>
                    <label className="form-label form-label-date">To Date</label>
                    <input
                      type="date"
                      className="inputText2 inputText2-ps"
                      value={toDate}
                      min={fromDate}
                      disabled={fromDate === ""}
                      onChange={(e) => setToDate(e.target.value)}
                      onKeyDown={(e) => e.preventDefault()}
                      onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    />
                  </div>
                </div>
                <div className="mb-3 gap-2 reports-col flex-wrap item-attribute-section">
                  <div className="column d-flex align-items-center mb-2" style={{ flex: "1 1 48%" }}>
                    <Image
                      className="icon"
                      src={IMAGE_TYPES.BOX_IMAGE}
                      alt=""
                    />
                    <input
                      type="text"
                      className="inputText21"
                      placeholder="Item"
                      value={item}
                      maxlength="20"
                      onChange={(e) => setItem(e.target.value)}
                    />
                  </div>

                  {attributes.map((attr, index) => (
                    <div key={index}
                      className="column d-flex align-items-center mb-2"
                      style={{ flex: "1 1 calc(50% - 10px)" }}>
                      <Image className="icon" src={IMAGE_TYPES.BOX_IMAGE} alt="" />
                      <input
                        type="text"
                        className="inputText21"
                        placeholder={`Attribute ${index + 1}`}
                        maxLength="20"
                        value={attr}
                        onChange={(e) => {
                          const updated = [...attributes];
                          updated[index] = e.target.value;
                          setAttributes(updated);
                        }} 

                      />
                      {index === attributes.length - 1 && attributes.length < 5 && (
                        <button type="button" className="btn btn-sm btn-success ms-2" onClick={() => {setAttributes([...attributes, '']);}} title="Add attribute"> +
                   </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => {setFromDate(""); setToDate(""); setItem(""); setAttributes([""]); setResetFilters(true); setTimeout(() => {getOwnerDataList("", "", "", [""]);}, 0);}}>Reset</button>
                <button className="btn btn-primary" data-bs-dismiss="modal" onClick={() => getOwnerDataList(fromDate, toDate, item, attributes)} disabled={fromDate === "" && toDate === "" && item === "" && attributes.every((attr) => !attr)}>Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OwnerViewData isShowModel={isShowModel} onClose={handleCreate} data={ownerData} onSuccess={getOwnerDataList}/>
      <OwnwerSendMessage  isShowModel={showModel} onClose={handleModel} selectedRows={selectedRows} onSuccess={() => {getOwnerDataList();setClearSelection(true);}}/>
    </ComponentHandler>
  );
}
export default Reports;
